let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aNswy")).then(() => parcelRequire('gwNsH'));